import React, {useMemo} from "react";
import "./checkouts.css";
import Page from "../../components/page/Page";
import CheckoutsTable from "./CheckoutsTable";
import SkeletonItem from "../../components/skeleton/SkeletonItem";
import {LineChart} from "../../components/charts/base/LineChart";
import useAppContext from "../../hooks/useAppContext";
import {getFriendlyDate} from "../../utils/friendlyDate";
import {CHART_COLORS} from "../../components/charts/consts/COLOR_SETS";

interface AssociativeArray {
    [key: string]: number
}

const Checkouts = () => {
    const { data: { lastDaysCheckouts } } = useAppContext();

    const labels = lastDaysCheckouts.data?.map((row: any) => getFriendlyDate(new Date(row.days)));
    const dataSets = [
        { label: 'Recovered', values: lastDaysCheckouts.data.map((ldm: any) => ldm.total_converted_checkouts), backgroundColor: CHART_COLORS[2].transparent, borderColor: CHART_COLORS[2].transparent },
        { label: 'Completed', values: lastDaysCheckouts.data.map((ldm: any) => ldm.total_completed_checkouts), backgroundColor: CHART_COLORS[0].transparent, borderColor: CHART_COLORS[0].transparent },
        { label: 'Recoverable', values: lastDaysCheckouts.data.map((ldm: any) => ldm.total_recoverable_checkouts), backgroundColor: CHART_COLORS[5].solid, borderColor: CHART_COLORS[5].transparent },
        { label: 'All Checkouts', values: lastDaysCheckouts.data.map((ldm: any) => ldm.total_checkouts), backgroundColor: CHART_COLORS[4].transparent, borderColor: CHART_COLORS[4].transparent },
    ];
    const isDataLoaded = useMemo(() => !!lastDaysCheckouts.data?.length, [lastDaysCheckouts.data?.length]);
    const totalCheckouts = lastDaysCheckouts.data.reduce((acc: number, row: any) => acc + row.total_checkouts, 0);
    const totalAbandoned = lastDaysCheckouts.data.reduce((acc: number, row: any) => acc + row.total_recoverable_checkouts + row.total_converted_checkouts, 0);
    const totalRecoveredCheckouts = lastDaysCheckouts.data.reduce((acc: number, row: any) => acc + row.total_converted_checkouts, 0);
    return (
        <Page
            className="abandoned-checkouts-container"
            title="Abandoned Checkouts"
            subtitle="A list of all checkouts that were abandoned before being converted to orders"
        >
            <div className="checkouts-charts-layout">
                <div className="checkouts-charts-item grid-8">{lastDaysCheckouts.isLoading ? <SkeletonItem height={200} gridSpan={8} /> :
                    <LineChart
                        data={lastDaysCheckouts.data}
                        labels={labels}
                        dataSets={dataSets}
                        isDataLoaded={isDataLoaded}
                    />
                }</div>
                <div className="checkouts-charts-item grid-4">
                    {lastDaysCheckouts.isLoading ? <SkeletonItem height={200} gridSpan={4} /> :
                        <div className="weekly-summary">
                            <div className="total-checkouts"><div>{totalAbandoned}</div><span>Abandoned <span>(Last 7 Days)</span></span></div>
                            <div className="total-converted"><div>{totalRecoveredCheckouts}</div><span>Recovered <span>(Last 7 Days)</span></span></div>
                        </div>
                    }
                </div>
            </div>
            <CheckoutsTable />
        </Page>
    );
}

export default Checkouts;